var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000002442(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166992,
    y: 0.635742,
    width: 41.9141,
    height: 41.9141,
    rx: 6.44833,
    fill: "#D7D7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1352_1036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9209 26.8436C31.9209 26.8436 31.154 22.001 27.4024 19.7572C27.4024 19.7572 28.1088 11.0057 21.8701 6.83317C21.4878 6.57746 20.99 6.57742 20.6076 6.83307C14.3691 11.0042 15.0769 19.7557 15.0769 19.7557C11.3269 22.001 10.5584 26.8436 10.5584 26.8436C10.4148 27.1106 10.4519 27.4254 10.6309 27.5998C10.8639 27.8297 11.3284 27.8112 11.5923 27.4748C12.2837 26.7634 13.1587 25.9763 14.2389 25.2186C14.8917 24.7603 15.5229 24.3822 16.1108 24.0674L16.2883 25.072L21.242 25.1908L26.1957 25.072L26.3731 24.0674C26.9595 24.3822 27.5923 24.7618 28.245 25.2186C29.3253 25.9763 30.2003 26.7618 30.8916 27.4748C31.1555 27.8097 31.62 27.8297 31.853 27.5998C32.0305 27.4239 32.0691 27.1106 31.9256 26.8436H31.9209Z",
    fill: "url(#paint0_linear_1352_1036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9101 29.0953H25.4471L25.8993 26.1509H16.5166L16.9101 29.0953Z",
    fill: "#7A3CB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6759 30.0811C18.25 30.0811 17.9043 30.4267 17.9043 30.8527V34.0795C17.9043 34.5054 18.25 34.8511 18.6759 34.8511C19.1018 34.8511 19.4475 34.5054 19.4475 34.0795V30.8527C19.4475 30.4267 19.1018 30.0811 18.6759 30.0811Z",
    fill: "#7A3CB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6881 30.0811C23.2622 30.0811 22.9165 30.4267 22.9165 30.8527V34.0795C22.9165 34.5054 23.2622 34.8511 23.6881 34.8511C24.114 34.8511 24.4597 34.5054 24.4597 34.0795V30.8527C24.4597 30.4267 24.114 30.0811 23.6881 30.0811Z",
    fill: "#7A3CB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2076 30.0811C20.7817 30.0811 20.436 30.4267 20.436 30.8527V37.3063C20.436 37.7323 20.7817 38.0779 21.2076 38.0779C21.6336 38.0779 21.9792 37.7323 21.9792 37.3063V30.8527C21.9792 30.4267 21.6336 30.0811 21.2076 30.0811Z",
    fill: "#7A3CB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_1036",
    x1: 21.2417,
    y1: 6.44092,
    x2: 21.2417,
    y2: 29.3309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A3CB0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1352_1036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.54,
    height: 31.6388,
    fill: "white",
    transform: "translate(10.4707 6.43945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000002442);
export default __webpack_public_path__ + "static/media/Group-1000002442.526c274b147d590b808c7e0a7f054e7c.svg";
export { ForwardRef as ReactComponent };